import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function CurvedArrowRightIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                    d="M8.50094 19.9995C8.15894 19.9995 7.82594 19.8245 7.63994 19.5095C7.35794 19.0335 7.51594 18.4205 7.98994 18.1395C10.6149 16.5835 14.4999 13.5565 14.4999 11.9995C14.4999 10.4395 10.6159 7.41349 7.98994 5.85949C7.51594 5.57849 7.35794 4.96549 7.63994 4.48949C7.92094 4.01549 8.53394 3.85849 9.00994 4.13949C10.2599 4.87949 16.4999 8.73749 16.4999 11.9995C16.4999 15.2605 10.2609 19.1195 9.00994 19.8595C8.84994 19.9545 8.67394 19.9995 8.50094 19.9995Z"
                />
            </g>
        </SvgIcon>
    )
}
